<template>
  <Tile
    :title="pluraliseString('Report', entries.length)"
    :entries="entries"
    :selected="selected"
    :tooltip="tooltip"
  />
</template>

<script>
import Tile from 'components/partials/timeline/partials/Tile'
import tileMixin from 'components/partials/timeline/partials/tileMixin'

export default {
  components: {
    Tile
  },
  mixins: [tileMixin]
}
</script>
